<template>
  <div>
    <div class="text-center my-4">
      <CentralHeader
          title="Privacy Policy"
          class="mt-12 text-darkFont"
      ></CentralHeader>
    </div>
    <section
      class="bg-white mx-auto rounded-lg p-14 max-w-7xl sm:px-4 lg:px-16 pb-24"
    >
      <div class="prose mt-4">
        <p class="prose">
          The privacy of your data — which is yours and not ours — is important
          to us. We’ll only ever access your account to help you with a problem
          or squash a software bug. We’ll never open any uploaded files unless
          you ask ask ask us to. We log all access to all accounts by IP
          address, so we can verify that no unauthorized access has happened for
          as long as the are kept.
        </p>
      </div>

      <h2 class="font-open-sans text-xl text-darkgreen mt-6 font-bold mb-3">
        Identity & Access
      </h2>
      <div class=" text-base prose">
        <p class="">
          When you sign up for Vectric products & services, we ask for your
          name, email address and sometimes a delivery address (if you want our
          software on physical media like a memory stick). That’s just so we can
          personalize your new account, and we can send you invoices, updates,
          free projects, ideas or other essential information.
        </p>
        <p class="">
          We’ll never sell your personal info to third parties, and we won’t use
          your name or company in marketing statements without your permission,
          either. When you write to Vectric with a question or to ask for help,
          we’ll keep that correspondence, and the email address, for future
          reference.
        </p>
        <p class="">
          When you browse our marketing pages, we’ll track that for statistical
          purposes only (like conversion rates and to test new designs). We also
          store any information you volunteer, like surveys, for as long as it
          makes sense.
        </p>
        <p class="">
          The only times we’ll ever share your info: To provide products or
          services you’ve requested, with your permission. To investigate,
          prevent, or take action regarding illegal activities, suspected fraud,
          situations involving potential threats to the physical safety of any
          person, violations of our End User License Agreement or as otherwise
          required by law.
        </p>
        <p class="">
          If Vectric is acquired by or merged with another company — we don’t
          plan on that, but if it happens — we’ll notify you well before any
          info about you is transferred and becomes subject to a different
          privacy policy.
        </p>
      </div>

      <h2 class="font-open-sans text-xl text-darkgreen mt-6 font-bold mb-3">
        Cookies
      </h2>
      <div class="prose text-base">
        <p>
          In order to improve our services and online experience, and to provide
          more convenient, relevant and useful experiences to you, we and our
          third party providers may use “cookies” to track your activities.
          Third Parties Vectric uses third party service providers and hosting
          partners to provide the necessary hardware, software, networking,
          storage and eCommerce technology required to deliver our products and
          services to you.
        </p>
        <p>
          A current list of third party providers is available upon request from
          your Vectric support team. Software When you use our software products
          we send and store relevant information about your product, such as the
          version and type of operating system you are using in order to provide
          the correct update information.
        </p>
      </div>
      <h2 class="font-open-sans text-xl text-darkgreen mt-6 font-bold mb-3">
        Law Enforcement
      </h2>
      <div class="prose">
        <p>
          Vectric won’t hand your data over to law enforcement unless a court
          order says we have to. We reject requests from local and federal law
          enforcement when they seek data without a court order. And unless
          we’re legally prevented from it, we’ll always inform you when such
          requests are made.
        </p>
      </div>

      <h2 class="font-open-sans text-xl text-darkgreen mt-6 font-bold mb-3">
        Encryption
      </h2>
      <div class="prose">
        <p>
          All data is encrypted via SSL/TLS when transmitted from our servers to
          your browser. The database backups are also encrypted. You data is
          encrypted, and sent using HTTPS when in transport and encrypted when
          stored in database tables, temporary files, and backups. At times,
          when we need to read your information, it is unencrypted but we are
          always careful to secure your data internally.
        </p>
      </div>
      <h2 class="font-open-sans text-xl text-darkgreen mt-6 font-bold mb-3">
        Deleted Data
      </h2>
      <div class="prose">
        <p>
          When you cancel your account, we will delete your personal data with
          the exception of what we need to keep as a record of your original
          purchase(s) and the data required for us to fulfil our obligations to
          you (for example, free upgrades and free lifetime support).
        </p>
      </div>
      <h2 class="font-open-sans text-xl text-darkgreen mt-6 font-bold mb-3">
        Changes & questions
      </h2>
      <div class="prose">
        <p class="">
          Vectric may update this policy once in a blue moon — we’ll notify you
          about significant changes by emailing the account owner or by placing
          a prominent notice on our site. You can access, change or delete your
          personal information at any time by contacting our support team.
        </p>
        <p>
          Questions about this privacy policy? Please get in touch and we’ll be
          happy to answer them!
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import CentralHeader from "../components/shared/CentralHeader.vue";

export default {
  name: "Privacy",
  components: {CentralHeader}
};
</script>

<style scoped></style>
